const API_HOST = "https://kafka10.intellicar.in";

export default function api(path, body) {
  return fetch(API_HOST + path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body ? JSON.stringify(body) : null,
  }).then((rsp) => rsp.json());
}
